import React, { useRef, useState } from "react"
import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@mui/material/Modal';
import ImageEditor from "../../common/ImageCropModal";

import { translate } from '../../helper';
import ThemeDesign from '../ThemeDesign';
import LocalStorage from '../../defined/localStorage';
import { useSelector } from "react-redux";

const brand = JSON.parse(LocalStorage.getItem('branding'))


function ScreenDesign({
    onSubmit,
    screenFiles,
    setScreenFiles,
    topBannerColor,
    backgroundColor,
    buttonColor,
    logo,
    setTopBannerColor,
    setBackgroundColor,
    setButtonColor,
    setLogo,
    onCancel,
    logoError,
    setLogoError,
    loading,
    send,
    onPreview
}) {
    const [isEditorOpen1, setIsEditorOpen1] = useState(false);
    const [isEditorOpen2, setIsEditorOpen2] = useState(false);
    const [isEditorOpen3, setIsEditorOpen3] = useState(false);

    const [screenImage1, setScreenImage1] = useState(null);
    const [screenImage2, setScreenImage2] = useState(null);
    const [screenImage3, setScreenImage3] = useState(null);

    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const fileInputRef3 = useRef(null);


    const handleCloseEditor1 = () => {
        setIsEditorOpen1(false)
        let input = document.getElementById('myFile1');
        if (input) {
            input.value = ''
        }
        fileInputRef1.current.value = '';

        setScreenImage1(null);
    }

    const handleCloseEditor2 = () => {
        setIsEditorOpen2(false)
        let input = document.getElementById('myFile2');
        if (input) {
            input.value = ''
        }
        fileInputRef2.current.value = '';

        setScreenImage2(null);
    }

    const handleCloseEditor3 = () => {
        setIsEditorOpen3(false)
        let input = document.getElementById('myFile3');
        if (input) {
            input.value = ''
        }
        fileInputRef3.current.value = '';

        setScreenImage3(null);
    }

    const handleCroppedImage1 = (img) => {
        let arr = img.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let file = new File([u8arr], screenImage1.name, { type: mime });
        setScreenFiles({
            ...screenFiles,
            screen1: file
        })
        handleCloseEditor1();
    }

    const handleCroppedImage2 = (img) => {
        let arr = img.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let file = new File([u8arr], screenImage2.name, { type: mime });
        setScreenFiles({
            ...screenFiles,
            screen2: file
        })
        handleCloseEditor2();
    }

    const handleCroppedImage3 = (img) => {
        let arr = img.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let file = new File([u8arr], screenImage3.name, { type: mime });
        setScreenFiles({
            ...screenFiles,
            screen3: file
        })
        handleCloseEditor3();
    }

    return (
        <div style={{ width: "100%" }}>
            {/* <SubHeader
                label="welcomeScreens"
                // button={header&&"sendSetupLink"} commented by Krishna Kumar (Finoit) - MOV-4
                onClick={send}
            />
            <div
                style={{
                    width: "100%",
                    margin: "20px 0",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 0",
                    borderBottom: "1px solid #E5E7EB"
                }}
            >
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen1')} - {translate('maxText')}
                    </span>
                    <input
                        style={{
                            width: "70%",
                            fontWeight: "400",
                            fontSize: "14px !important",
                            border: "1px solid #DADADA",
                            borderRadius: "4px !important",
                            padding: "7px 10px",
                            lineHeight: "16px"
                        }}
                        name="screen1"
                        value={screenNames.screen1}
                        onChange={handleScreenName}
                    />
                </div>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        // alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen1')} - {translate('maxImage')}
                    </span>
                    <div
                        style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <div
                            style={{
                                width: "300px",
                                height: "120px",
                                borderRadius: "4px",
                                border: "1px solid #DADADA",
                                margin: "10px 0",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            {screenFiles?.screen1 && <img
                                src={imageUrl(screenFiles.screen1)}
                                alt="logo"
                                style={{ width: "120px" }}
                                accept="image/png, image/jpg, image/gif"
                            />}
                        </div>
                        {error?.screen1?.length > 0 && <p
                            style={{
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "21px",
                                color: "#f00",
                                margin: "10px 0"
                            }}
                        >
                            {error?.screen1}
                        </p>}
                        <div
                            style={{
                                borderRadius: "4px",
                                background: `${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}`,
                                border: "1px solid rgba(255, 255, 255, 0.52)",
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#fff",
                                textTransform: "capitalize",
                                textAlign: "center",
                                width: "142px",
                                cursor: "pointer",
                                position: "relative",
                                marginTop: "10px",
                                padding: "5px"
                            }}
                        >
                            {translate('upload')}
                            <input ref={fileInputRef1} onChange={(e) => onFileUpload1(e, 'screen1')} style={{ position: "absolute", left: 0, width: "100%", opacity: 0, padding: 0, cursor: "pointer" }} type="file" id="myFile" name="filename"></input>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    margin: "20px 0",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 0",
                    borderBottom: "1px solid #E5E7EB"
                }}
            >
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen2')} - {translate('maxText')}
                    </span>
                    <input
                        style={{
                            width: "70%",
                            fontWeight: "400",
                            fontSize: "14px !important",
                            border: "1px solid #DADADA",
                            borderRadius: "4px !important",
                            padding: "7px 10px",
                            lineHeight: "16px"
                        }}
                        name="screen2"
                        value={screenNames.screen2}
                        onChange={handleScreenName}
                    />
                </div>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        // alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen2')} - {translate('maxImage')}
                    </span>
                    <div
                        style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <div
                            style={{
                                width: "300px",
                                height: "120px",
                                borderRadius: "4px",
                                border: "1px solid #DADADA",
                                margin: "10px 0",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            {screenFiles?.screen2 && <img
                                src={imageUrl(screenFiles.screen2)}
                                alt="logo"
                                style={{ width: "120px" }}
                                accept="image/png, image/jpg, image/gif"
                            />}
                        </div>
                        {error?.screen2?.length > 0 && <p
                            style={{
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "21px",
                                color: "#f00",
                                margin: "10px 0"
                            }}
                        >
                            {error?.screen2}
                        </p>}
                        <div
                            style={{
                                borderRadius: "4px",
                                background: `${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}`,
                                border: "1px solid rgba(255, 255, 255, 0.52)",
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#fff",
                                textTransform: "capitalize",
                                textAlign: "center",
                                width: "142px",
                                cursor: "pointer",
                                position: "relative",
                                marginTop: "10px",
                                padding: "5px"
                            }}
                        >
                            {translate('upload')}
                            <input ref={fileInputRef2} onChange={(e) => onFileUpload2(e, 'screen2')} style={{ position: "absolute", left: 0, width: "100%", opacity: 0, padding: 0, cursor: "pointer" }} type="file" id="myFile2" name="filename"></input>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    margin: "20px 0",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 0",
                    borderBottom: "1px solid #E5E7EB"
                }}
            >
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen3')} - {translate('maxText')}
                    </span>
                    <input
                        style={{
                            width: "70%",
                            fontWeight: "400",
                            fontSize: "14px !important",
                            border: "1px solid #DADADA",
                            borderRadius: "4px !important",
                            padding: "7px 10px",
                            lineHeight: "16px"
                        }}
                        name="screen3"
                        value={screenNames.screen3}
                        onChange={handleScreenName}
                    />
                </div>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        padding: "10px 0",
                        // alignItems: "center"
                    }}
                >
                    <span
                        style={{
                            width: "30%",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}
                    >
                        {translate('screen3')} - {translate('maxImage')}
                    </span>
                    <div
                        style={{
                            width: "70%",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <div
                            style={{
                                width: "300px",
                                height: "120px",
                                borderRadius: "4px",
                                border: "1px solid #DADADA",
                                margin: "10px 0",
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            {screenFiles?.screen3 && <img
                                src={imageUrl(screenFiles.screen3)}
                                alt="logo"
                                style={{ width: "120px" }}
                                accept="image/png, image/jpg, image/gif"
                            />}
                        </div>
                        {error?.screen3?.length > 0 && <p
                            style={{
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "21px",
                                color: "#f00",
                                margin: "10px 0"
                            }}
                        >
                            {error?.screen3}
                        </p>}
                        <div
                            style={{
                                borderRadius: "4px",
                                background: `${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}`,
                                border: "1px solid rgba(255, 255, 255, 0.52)",
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#fff",
                                textTransform: "capitalize",
                                textAlign: "center",
                                width: "142px",
                                cursor: "pointer",
                                position: "relative",
                                marginTop: "10px",
                                padding: "5px"
                            }}
                        >
                            {translate('upload')}
                            <input ref={fileInputRef3} onChange={(e) => onFileUpload3(e, 'screen3')} style={{ position: "absolute", left: 0, width: "100%", opacity: 0, padding: 0, cursor: "pointer" }} type="file" id="myFile3" name="filename"></input>
                        </div>
                    </div>
                </div>
            </div> */}
            <ThemeDesign
                header={false}
                topBanner={true}
                // background={true} 
                button={true}
                onSubmit={onSubmit}
                onPreview={onPreview}
                topBannerColor={topBannerColor}
                backgroundColor={backgroundColor}
                buttonColor={buttonColor}
                logo={logo}
                setTopBannerColor={setTopBannerColor}
                setBackgroundColor={setBackgroundColor}
                setButtonColor={setButtonColor}
                setLogo={setLogo}
                onCancel={onCancel}
                logoError={logoError}
                setLogoError={setLogoError}
                loading={loading}
            />
            <Modal open={isEditorOpen1} onClose={handleCloseEditor1}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "60%", minHeight: "calc(var(--fs-hero)*9.433962)", position: "relative", background: "#000", padding: "var(--sp-md2)" }}>
                        <ImageEditor img={screenImage1} setCroppedImage={handleCroppedImage1} handleCloseEditor={handleCloseEditor1} />
                    </div>
                </div>
            </Modal>

            <Modal open={isEditorOpen2} onClose={handleCloseEditor2}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "60%", minHeight: "calc(var(--fs-hero)*9.433962)", position: "relative", background: "#000", padding: "var(--sp-md2)" }}>
                        <ImageEditor img={screenImage2} handleCloseEditor={handleCloseEditor2} setCroppedImage={handleCroppedImage2} />
                    </div>
                </div>
            </Modal>

            <Modal open={isEditorOpen3} onClose={handleCloseEditor3}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "60%", minHeight: "calc(var(--fs-hero)*9.433962)", position: "relative", background: "#000", padding: "var(--sp-md2)" }}>
                        <ImageEditor img={screenImage3} setCroppedImage={handleCroppedImage3} handleCloseEditor={handleCloseEditor3}  />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ScreenDesign